"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const breakpoints_1 = __importDefault(require("./foundations/breakpoints"));
const colors_1 = __importDefault(require("./foundations/colors"));
const fonts_1 = __importDefault(require("./foundations/fonts"));
const styles_1 = __importDefault(require("../components/Alert/styles"));
const styles_2 = __importDefault(require("../components/Button/styles"));
const styles_3 = __importDefault(require("../components/Card/styles"));
const styles_4 = __importDefault(require("../components/Checkbox/styles"));
const styles_5 = __importDefault(require("../components/CloseButton/styles"));
const styles_6 = require("../components/FormControl/styles");
const styles_7 = __importDefault(require("../components/FormInputPassword/styles"));
const styles_8 = __importDefault(require("../components/FormInputPhoneNumber/styles"));
const styles_9 = __importDefault(require("../components/FormInputPin/styles"));
const styles_10 = __importDefault(require("../components/FormInputSelect/styles"));
const styles_11 = __importDefault(require("../components/Input/styles"));
const styles_12 = __importDefault(require("../components/Link/styles"));
const styles_13 = __importDefault(require("../components/Select/styles"));
const styles_14 = __importDefault(require("../components/SkuImage/styles"));
const styles_15 = __importDefault(require("../components/Slider/styles"));
const styles_16 = __importDefault(require("../components/Switch/styles"));
const styles_17 = __importDefault(require("../components/Table/styles"));
const styles_18 = __importDefault(require("../components/Tabs/styles"));
const styles_19 = __importDefault(require("../components/Tooltip/styles"));
const styles_20 = __importDefault(require("../components/Typography/styles"));
const extend_theme_1 = require("../theme-tools/extend-theme");
const theme = (0, extend_theme_1.extendTheme)({
    colors: colors_1.default,
    fonts: fonts_1.default,
    breakpoints: breakpoints_1.default,
    components: {
        Alert: styles_1.default,
        Button: styles_2.default,
        Card: styles_3.default,
        Checkbox: styles_4.default,
        CloseButton: styles_5.default,
        Link: styles_12.default,
        SkuImage: styles_14.default,
        Switch: styles_16.default,
        Tabs: styles_18.default,
        Typography: styles_20.default,
        FormError: styles_6.FormError,
        Input: styles_11.default,
        Form: styles_6.Form,
        FormInputPhoneNumber: styles_8.default,
        FormInputSelect: styles_10.default,
        FormInputPassword: styles_7.default,
        FormInputPin: styles_9.default,
        Select: styles_13.default,
        Slider: styles_15.default,
        Table: styles_17.default,
        Tooltip: styles_19.default,
    },
});
exports.default = theme;
